import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { CustomButton } from "components/CustomButton";

export function SuccessModal({ open, handleClose, themeColor, }) {
  const defaultColor = themeColor?.navigation?.buttons?.backgroundColor || '#000000'
  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ backdropFilter: 'blur(2px)', }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          maxWidth: 470,
          bgcolor: '#FFFFFF',
          p: '25px',
          borderRadius: '10px',
          gap: '30px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box
          p={1}
          gap="20px"
          width="100%"
          display="flex"
          alignItems="center"
          flexDirection="column"
          justifyContent="center"
        >
          <Box
            component="i"
            fontSize="50px"
            color="#4CAF50"
            className="icon-grid_ativo"
          />
          <Box display="flex" flexDirection="column" gap="10px" textAlign="center">
            <Typography variant="body1" color="#5D5D5D" fontSize="15px" style={{ fontWeight: 'bold' }}>
              Você está quase lá!
            </Typography>
            <Typography variant="body1" color="#5D5D5D" fontSize="15px" >
              Enviamos um e-mail para o endereço informado com o link de finalização do cadastro.
            </Typography>
          </Box>

        </Box>

        <Box display="flex" justifyContent="center" width="100%" gap={'15px'}>
          <CustomButton
            size="sm"
            fullWidth
            variant="contained"
            style={{ maxWidth: '174px' }}
            defaultColor={defaultColor}
            onClick={handleClose}
          >
            Ok
          </CustomButton>

        </Box>


      </Box>
    </Modal>
  );
}
